export default __webpack_public_path__ + "d60cb9cdb5edb22875992266d73377c9.jpg";